export function NonNullish<T>(value: T): NonNullable<T> {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'bigint':
      return value;

    default:
      if (!value) {
        throw new Error('Value must not be nullish');
      }

      return value;
  }
}

export function assertNonNullish<T>(value: T): asserts value is NonNullable<T> {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'bigint':
      break;

    default:
      if (!value) {
        throw new Error('Value must not be nullish');
      }
  }
}
